import {
  GET_COACHING_SESSION_REQUESTING,
  GET_COACHING_SESSION_SUCCESS,
  GET_COACHING_SESSION_ERROR,
  UPDATE_COACHING_SESSION_REQUESTING,
  UPDATE_COACHING_SESSION_SUCCESS,
  UPDATE_COACHING_SESSION_ERROR,
  CREATE_COACHING_SESSION_REQUESTING,
  CREATE_COACHING_SESSION_SUCCESS,
  CREATE_COACHING_SESSION_ERROR,
  GET_ACTIVE_COACHING_SESSION_SUCCESS,
  GET_ACTIVE_COACHING_SESSION_ERROR,
  GET_ACTIVE_COACHING_SESSION_REQUESTING,
  GET_COACHING_RESOURCES_SUCCESS,
  GET_COACHING_RESOURCES_ERROR,
  GET_COACHING_RESOURCES_REQUESTING,
  VISIT_RESOURCE_REQUESTING,
  SUBMIT_RESOURCE_FEEDBACK_REQUESTING,
  SUBMIT_RESOURCE_FEEDBACK_SUCCESS,
  SUBMIT_RESOURCE_FEEDBACK_ERROR,
} from "./constants";
import { cloneDeep } from "lodash";

import moment from "moment-timezone";
import { LOGOUT } from "../login/constants";
import { ICoachingReducer } from "./types";

const initialState: ICoachingReducer = {
  error: "",
  requesting: false,
  feedbackRequesting: false,
  resourcesRequesting: false,
  coachingResources: [],
  coachingSession: {
    _id: "",
    clientId: "",
    userId: "",
    coachId: "",
    coachName: "",
    coachPicture: "",
    goals: [],
    sessions: [],
    resources: [],
    isRemoved: false,
    isFinished: false,
    isForbidden: false,
    endCoachingMessage: "",
    totalDone: 0,
  },
};

const reducer = function userReducer(
  state: ICoachingReducer = initialState,
  action,
): ICoachingReducer {
  switch (action.type) {
    case GET_COACHING_RESOURCES_REQUESTING:
      return {
        ...state,
        resourcesRequesting: true,
      };

    case GET_ACTIVE_COACHING_SESSION_REQUESTING:
    case CREATE_COACHING_SESSION_REQUESTING:
    case UPDATE_COACHING_SESSION_REQUESTING:
    case GET_COACHING_SESSION_REQUESTING: {
      return {
        ...state,
        requesting: true,
      };
    }

    case CREATE_COACHING_SESSION_SUCCESS:
    case GET_ACTIVE_COACHING_SESSION_SUCCESS:
    case GET_COACHING_SESSION_SUCCESS: {
      const { sessions, resources, goals } = action.payload;
      const coachingSession = state.coachingSession || {};
      const newCoachingSession = {
        ...cloneDeep(coachingSession),
        ...cloneDeep(action.payload),
      };
      return {
        ...state,
        requesting: false,
        coachingSession: newCoachingSession,
      };
    }

    case UPDATE_COACHING_SESSION_SUCCESS: {
      return {
        ...state,
        requesting: false,
        coachingSession: {
          ...state.coachingSession,
          ...action.payload,
        },
      };
    }

    case GET_COACHING_RESOURCES_ERROR:
      return {
        ...state,
        resourcesRequesting: false,
      };

    case GET_ACTIVE_COACHING_SESSION_ERROR:
    case CREATE_COACHING_SESSION_ERROR:
    case UPDATE_COACHING_SESSION_ERROR:
    case GET_COACHING_SESSION_ERROR: {
      return {
        ...state,
        requesting: false,
        error: action.payload,
      };
    }

    case GET_COACHING_RESOURCES_SUCCESS: {
      return {
        ...state,
        resourcesRequesting: false,
        coachingResources: action.payload,
      };
    }

    case VISIT_RESOURCE_REQUESTING: {
      const coachingResources = state.coachingResources.map(el => {
        if (el._id === action.payload.resourceId) {
          return {
            ...el,
            lastViewDate: new Date(),
            isVisited: true,
          };
        }
        return el;
      });

      return {
        ...state,
        coachingResources,
      };
    }

    case SUBMIT_RESOURCE_FEEDBACK_REQUESTING: {
      return {
        ...state,
        feedbackRequesting: true,
      };
    }

    case SUBMIT_RESOURCE_FEEDBACK_SUCCESS: {
      const coachingResources = state.coachingResources.map(el => {
        if (el._id === action.payload.resourceId) {
          return {
            ...el,
            rating: action.payload.rating,
          };
        }
        return el;
      });
      return {
        ...state,
        coachingResources,
        feedbackRequesting: false,
      };
    }

    case SUBMIT_RESOURCE_FEEDBACK_ERROR: {
      return {
        ...state,
        feedbackRequesting: false,
        error: action.payload,
      };
    }

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
